export default {
    message: {

    }
}